import type { LanguageCode, Platform } from '@/types'

export const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'Sabha'

export const PLATFORM_LABEL: Record<Platform, string> = {
  teams: 'Microsoft Teams',
  meet: 'Google Meet',
  zoom: 'Zoom',
  device: 'This device',
}

export const LANGUAGE_LABEL: Record<LanguageCode, string> = {
  'en-IN': 'English (India)',
  'hi-IN': 'Hindi',
  'en-US': 'English (US)',
  'mr-IN': 'Marathi',
  'ta-IN': 'Tamil',
  'te-IN': 'Telugu',
  identify: 'Auto-detect',
}

/** Tailwind breakpoints, mirrored for JS media queries. Keep in sync. */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const

/** Below this width the sidebar becomes an overlay drawer. */
export const SIDEBAR_BREAKPOINT = BREAKPOINTS.lg
